import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Login from '@/components/Login'
import Customer from '@/components/customer/'
import Product from '@/components/product/'
import Authorization from '@/components/authorization/'
Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      // name: 'home',
      component: Home,
      children: [{
          path: '/customer',
          name: '客户管理',
          icon: 'el-icon-service',
          component: Customer
        },
        {
          path: '/product',
          name: '产品管理',
          icon: 'el-icon-goods',
          component: Product
        },
        {
          path: '/authorization',
          name: '授权管理',
          icon: 'el-icon-view',
          component: Authorization
        },
        {
          path:'/',
          redirect: '/customer',
          hidden:true
        }
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js